<div class="tab-list">
  @for (item of items; track $index) {
    @if (item.url) {
      <button class="item-list" [ngClass]="{ active: item.active }" (click)="navigate(item.url)">
        <span *ngIf="item.iconName" class="material-symbols-outlined icon">{{ item.iconName }}</span>
        <span>{{ item.name }}</span>
      </button>
    } @else {
      <div class="item-list" [ngClass]="{ active: item.active }">
        <span *ngIf="item.iconName" class="material-symbols-outlined icon">{{ item.iconName }}</span>
        <span>{{ item.name }}</span>
      </div>
    }
  }
</div>
